import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import icon1 from '../../images/shape/trangle-shape.png'
import logo from '../../images/logo/synapz-logo-back.svg'
import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {

    const [mobailActive, setMobailState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    return (

        <div id="xb-header-area" className="header-area header-style-two header-transparent">
            <div className="header-top invisible">
                <span>Get 15% off on all annual plans until September 30! Join Texpo as we transform SEO 🚀</span>
                <span><Link onClick={ClickHandler} to="/">Learn more</Link><i className="far fa-angle-right"></i></span>
                <div className="header-shape">
                    <div className="shape shape--one"><img src={icon1} alt="" /></div>
                    <div className="shape shape--two"><img src={icon1} alt="" /></div>
                </div>
            </div>
            <div className={`xb-header stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="header__wrap ul_li_between">
                        <div className="header-logo">
                            <Link onClick={ClickHandler} to="/"><img src={logo} alt="" /></Link>
                        </div>
                        <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
                            <nav className="main-menu collapse navbar-collapse">
                                <ul>
                                    <li><Link onClick={(e) => {e.preventDefault(); scrollToSection('agentes');}} to="#agentes"><span>Agentes</span></Link></li>
                                    <li><Link onClick={(e) => {e.preventDefault(); scrollToSection('agentes');}} to="#agentes"><span>SDR</span></Link></li>
                                    <li><Link onClick={(e) => {e.preventDefault(); scrollToSection('agentes');}} to="#agentes"><span>Análise Preditiva</span></Link></li>
                                    <li><Link onClick={(e) => {e.preventDefault(); scrollToSection('agentes');}} to="#agentes"><span>Automação</span></Link></li>
                                    <li><Link onClick={(e) => {e.preventDefault(); scrollToSection('parceiros');}} to="#parceiros"><span>Parceiros</span></Link></li>
                                </ul>
                            </nav>
                            <div className="xb-header-wrap">
                                <div className={`xb-header-menu ${mobailActive ? "active" : ""}`}>
                                    <div className="xb-header-menu-scroll lenis lenis-smooth">
                                        <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobailState(!mobailActive)}></div>
                                        <div className="xb-logo-mobile xb-hide-xl">
                                            <Link onClick={ClickHandler} to="/" rel="home"><img src={logo}
                                                    alt=""/></Link>
                                        </div>
                                        <nav className="xb-header-nav">
                                            <MobileMenu/>
                                        </nav>
                                    </div>
                                </div>
                                <div className="xb-header-menu-backdrop"></div>
                            </div>
                        </div>
                        <div className="header-bar-mobile side-menu d-xl-none">
                            <button className="xb-nav-mobile" onClick={() => setMobailState(!mobailActive)}>
                                <i className="far fa-bars"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Header;